/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Content_PlaceholderInputs */

const en_settings_tickets_content_placeholder = /** @type {(inputs: Settings_Tickets_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your issue in detail...`)
};

const zh_settings_tickets_content_placeholder = /** @type {(inputs: Settings_Tickets_Content_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`详细描述你遇到的问题…`)
};

/**
* | output |
* | --- |
* | "Describe your issue in detail..." |
*
* @param {Settings_Tickets_Content_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_content_placeholder = /** @type {((inputs?: Settings_Tickets_Content_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Content_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_content_placeholder(inputs)
	return zh_settings_tickets_content_placeholder(inputs)
});
export { settings_tickets_content_placeholder as "settings.tickets.content_placeholder" }